<template>
  <div>
    <van-nav-bar
      title="关于我们"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/')"
    />
    <!-- <div class="bg-wave">
      <div class="logo">
        <van-image
          width="80px"
          height="80px"
          :src="require('../assets/images/logo.db2a1c2c.png')"
        />
      </div>
      <p class="about-us">关于我们</p>
    </div> -->
    <van-image :src="about_banner" style="width: 100%;" />
    <van-collapse v-model="activeName" accordion>
      <van-collapse-item
        :title="title[index]"
        :name="index"
        v-for="(item, index) in content"
        :key="index"
      >
        <div class="article_content" v-html="item"></div>
      </van-collapse-item>
      <!--      <van-collapse-item title="新手指引" name="2">
        <div class="article_content" v-html="guidelines">

        </div>
      </van-collapse-item>
      <van-collapse-item title="配资指南" name="3">
        <div class="article_content" v-html="guide">

        </div>
      </van-collapse-item>
      <van-collapse-item title="交易规则" name="4">
        <div class="article_content" v-html="rules">

        </div>
      </van-collapse-item>
      <van-collapse-item title="注册协议" name="5">
        <div class="article_content" v-html="agreement">

        </div>
      </van-collapse-item>
      <van-collapse-item title="公司资质" name="6">
        <div class="article_content" v-html="qualification">

        </div>
      </van-collapse-item>
      <van-collapse-item title="联系我们" name="7">
        <div class="article_content" v-html="contact">

        </div>
      </van-collapse-item>
      <van-collapse-item title="帮助中心" name="8">
        <div class="article_content" v-html="center">

        </div>
      </van-collapse-item>-->
    </van-collapse>
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
import CommonLoading from "./CommonLoading";
export default {
  name: "AboutUs",
  components: {
    CommonLoading,
  },
  data() {
    return {
      activeName: "0",
      type: [7, 12, 13, 6, 1, 8, 10, 17],
      content: ["", "", "", "", "", "", "", ""],
      title: [
        "关于我们",
        "新手指引",
        "配资指南",
        "交易规则",
        "注册协议",
        "公司资质",
        "联系我们",
        "帮助中心",
      ],
      about_us: "",
      guidelines: "",
      guide: "",
      rules: "",
      qualification: "",
      contact: "",
      center: "",
      agreement: "",
      about_banner: "",
    };
  },
  methods: {
    isActiveName() {
      let that = this;
      if (!that.$route.query.activeName) {
        that.activeName = "1";
      } else {
        that.activeName = that.$route.query.activeName;
      }
    },

    getImageBanner() {
      let that = this;
      // const toast = that.$ShowCommonLoading();
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "sysconfig",
            name: "aboutus_banner",
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            // toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.about_banner = resData.data;
          } else {
            // toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.$toast.fail(resData.msg);
          }
        })
        .catch(() => {
          // toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },

    getData() {
      let that = this;
      let type = that.type;
      for (let i = 0, len = type.length; i < len; i++) {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "protocol",
              type: type[i],
            },
          })
          .then((res) => {
            let resData = res.data;
            if (res.data.code == 1) {
              that.content[i] = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
            }
          });
      }
    },
  },
  mounted: function () {
    this.isActiveName();
    this.getData();
    this.getImageBanner();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.bg-wave {
  background: linear-gradient(0deg, #f44233, #ee0a24);
  height: 160px;
  overflow: hidden;
}

.logo {
  text-align: center;
  margin-top: 30px;
}
.about-us {
  margin: 0;
  text-align: center;
  font-size: 14px;
  color: white;
  font-weight: bold;
}
.article_content >>> img {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue